import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface BusinessActivity {
    id: number;
    name: string;
    code: string;
}

export const businessActivityApi = createApi({
  reducerPath: "businessActivityApi",
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    getBusinessActivities: builder.query<BusinessActivity[], void>({
      query: () => "/business-activity/",
    }),
  }),
});

export const { useGetBusinessActivitiesQuery } = businessActivityApi;
